import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BalanceSheetListComponent } from './balance-sheet-list/balance-sheet-list.component';
import { BalanceSheetCreateComponent } from './balance-sheet-create/balance-sheet-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: BalanceSheetListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: BalanceSheetCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'balance-sheet-create/:id',
        component: BalanceSheetCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BalanceSheetRoutingModule { }
